import { BoundedContent, Box, Link, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';

export function NotFound() {
    return (
        <BoundedContent>
            <Box marginTop={10} marginBottom={'7'} textAlign="center">
                <img
                    alt="ghost"
                    src="https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Brief/Ghost.png"
                    width={128}
                    height={128}
                />
                <Box marginTop={8}>
                    <Typography fontSize="x3large" fontWeight="bold">
                        {__("Boo. That page didn't turn up - but we're here to help.")}
                    </Typography>
                </Box>
                <Box marginTop={8} marginBottom={10}>
                    <Link href="/">{__('Get back to our homepage')}</Link>
                </Box>
            </Box>
        </BoundedContent>
    );
}
